module.exports = __webpack_public_path__ + "static/img/abHonor.39f8785f.png";